module.exports = __webpack_public_path__ + "img/header-weddingRingsFacettedConnections@2x.73ed5c6.jpg";